import { SERVICES } from "../../utils/constants";
import ServicesTemplate from "./ServicesTemplate";

export default function Services() {
  return <ServicesTemplate services={SERVICES} />;
}
